import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { serializeQueryParams } from 'src/app/service-helper';
import { environment } from 'src/environments/environment';
import { TranscriptionResultResponse } from '../transcription-list/transcription-list-item/models/transcription-list-item.model';
import {
  IResultDTO,
  UpdateContactReasons,
} from '../transcription-list/transcription-result/models/transcription-result.model';
import {
  GetTranscriptionsFilter,
  PagedTranscriptionGetAllResponse,
} from './models/transcription.service.model';
import {
  GetClientRequest,
  PagedGetClientsResponse,
} from '../../client/models/client.model';
import {
  GetUserPagedResponse,
  GetUserRequest,
} from '../../user/service/models/user.service.model';

@Injectable({ providedIn: 'root' })
export class TranscriptionService {
  private readonly baseURL: string = environment.apiUrl + '/api/Incident';

  constructor(private readonly http: HttpClient) {}

  get(
    filter: GetTranscriptionsFilter
  ): Observable<PagedTranscriptionGetAllResponse> {
    const params = serializeQueryParams(filter);
    const options = { params: params };

    return this.http.get<PagedTranscriptionGetAllResponse>(
      this.baseURL,
      options
    );
  }

  getClients(filter: GetClientRequest): Observable<PagedGetClientsResponse> {
    const params = serializeQueryParams(filter);
    const options = { params: params };
    return this.http.get<PagedGetClientsResponse>(
      this.baseURL + '/clients',
      options
    );
  }

  getAttendants(filter: GetUserRequest): Observable<GetUserPagedResponse> {
    const params = serializeQueryParams(filter);
    const options = { params: params };
    return this.http.get<GetUserPagedResponse>(
      this.baseURL + '/attendants',
      options
    );
  }

  getIds(filter: GetTranscriptionsFilter): Observable<string[]> {
    const params = serializeQueryParams(filter);
    const options = { params: params };
    return this.http.get<string[]>(this.baseURL + '/ids', options);
  }

  getTranscription(id: string): Observable<TranscriptionResultResponse> {
    return this.http.get<TranscriptionResultResponse>(
      `${this.baseURL}/${id}/Transcription`
    );
  }

  getAudioUri(id: string): Observable<string> {
    return this.http.get<string>(`${this.baseURL}/${id}/AudioUri`);
  }

  getAudioContent(uri: string): Observable<Blob> {
    return this.http.get(uri, { responseType: 'blob' });
  }

  getResult(id: string): Observable<IResultDTO> {
    return this.http.get<IResultDTO>(`${this.baseURL}/${id}/Result`);
  }

  getById(id: string): Observable<any> {
    return this.http.get<any>(this.baseURL + '/' + id);
  }

  submit(request: any): Observable<any> {
    return this.http.post(`${this.baseURL}/Submit`, request);
  }

  reprocess(ids: string[]): Observable<any> {
    return this.http.put(this.baseURL + '/' + ids + '/Reprocess', null);
  }

  update(id: string, request: any) {
    return this.http.put(this.baseURL + '/' + id, request);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(this.baseURL + '/' + id);
  }

  updateContactReasons(id: string, request: UpdateContactReasons) {
    return this.http.put(this.baseURL + '/' + id + '/Contact-Reason', request);
  }
}
